import React from 'react';
import Form from 'react-bootstrap/Form'
import jwtClient from '../../JwtClient';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Select from 'react-select';


export class PickupPointAddressBXB extends React.Component {
    regionsUrl = '/api/v1/address/bxb/regions';
    state = {
        regions: [], // {'value': '1', 'label': 'Kievskaya oblast'}
        cities: [],
        streets: [],
    };

    componentDidMount() {
        jwtClient.get(this.regionsUrl)
            .then((response) => {
                this.setState({regions: this.translate(response.data)});
            })
            .catch((error) => {
                if (error.response) {
                    this.props.showError(error.response.data);
                }
            });
    }

    sortByLabel = data => {
        data.sort(function (a, b) {
            if (a.label > b.label) {
                return 1;
            } else if (a.label < b.label) {
                return -1;
            }
            return 0;
        });
        return data;
    };

    translate = data => {
        let translated =  data.map((item) => {
            item['label'] = item['name'] !== "" ? item['name']  : item['id'];
            delete item['name'];
            item['value'] = item['id'];
            delete item['id'];
            return item;
        });
        return this.sortByLabel(translated);
    };

    getIdByLabel = (label, array) => {
        for (let i of array) {
            if (label === i.label) {
                return i.value;
            }
        }
    };

    loadCities = regionLabel => {
        const regionId = this.getIdByLabel(regionLabel, this.state.regions);
        return jwtClient.get(this.regionsUrl, {params: {region_id: regionId}})
            .then((response) => {
                this.setState({cities: this.translate(response.data)});
            })
            .catch((error) => {
                if (error.response) {
                    this.props.showError(error.response.data);
                }
            })
    };

    loadStreets = (cityName) => {
        const cityId = this.getIdByLabel(cityName, this.state.cities);
        return jwtClient.get(this.regionsUrl, {params: {city_id: cityId}})
            .then((response) => {
                this.setState({streets: this.translate(response.data)});
            })
            .catch((error) => {
                if (error.response) {
                    this.props.showError(error.response.data);
                }
            })

    };

    render() {
        const {
            values,
            errors,
            setFieldValue,
        } = this.props;
        return (
            <div>
                <Form.Group>
                    <Form.Group>
                        <Form.Group>
                            <Row>
                                <Col sm="6">
                                    {/*// TODO this is version without SELECT package, it needs to be finished*/}
                                    {/*// Currently SELECT operates with values as objects. Each value in onChange is object*/}
                                    {/*// with label and id. This object will be set as state and will be sent to backend.*/}
                                    {/*// So we need here to retrieve somehow both values: and lable and id. Currently we*/}
                                    {/*// operate only with value of option, with is string, not object.*/}
                                    {/*<InputGroup>*/}
                                    {/*    <Prepend text="Region"/>*/}
                                    {/*    <Form.Control*/}
                                    {/*        as="select"*/}
                                    {/*        onChange={(event) => {*/}
                                    {/*            setFieldValue('bxbPickupPointAddress.region', event.target.value);*/}
                                    {/*            setFieldValue('bxbPickupPointAddress.city', null);*/}
                                    {/*            setFieldValue('bxbPickupPointAddress.street', null);*/}
                                    {/*            this.setState({streets: []});*/}
                                    {/*            this.loadCities(event.target.value);*/}
                                    {/*        }}*/}
                                    {/*        value={values.bxbPickupPointAddress.region || ""}*/}
                                    {/*        isInvalid=*/}
                                    {/*            {*/}
                                    {/*                touched.bxbPickupPointAddress &&*/}
                                    {/*                touched.bxbPickupPointAddress.region &&*/}
                                    {/*                errors.bxbPickupPointAddress &&*/}
                                    {/*                errors.bxbPickupPointAddress.region*/}
                                    {/*            }*/}
                                    {/*    >*/}
                                    {/*        <option disabled defaultValue/>*/}
                                    {/*        {*/}
                                    {/*            this.state.regions.map(*/}
                                    {/*                (each, index) => (*/}
                                    {/*                    <option value={each["label"]} key={each["value"]}>{each["label"]}</option>)*/}
                                    {/*            )*/}
                                    {/*        }*/}
                                    {/*    </Form.Control>*/}
                                    {/*    <Form.Control.Feedback type="invalid">*/}
                                    {/*        {*/}
                                    {/*            errors.bxbPickupPointAddress &&*/}
                                    {/*            errors.bxbPickupPointAddress.region*/}
                                    {/*        }*/}
                                    {/*    </Form.Control.Feedback>*/}
                                    {/*</InputGroup>*/}
                                    <Select
                                        className="flex-fill"
                                        classNamePrefix="react-select"
                                        isSearchable
                                        value={values.bxbPickupPointAddress.region}
                                        onChange={(region) => {
                                            setFieldValue('bxbPickupPointAddress.region', region);
                                            setFieldValue('bxbPickupPointAddress.city', null);
                                            setFieldValue('bxbPickupPointAddress.street', null);
                                            this.setState({streets: []});
                                            this.loadCities(region.label);
                                        }}
                                        options={this.state.regions}
                                        placeholder="Region"
                                        isInvalid={true}
                                    />
                                    <small style={{color: 'red'}}>
                                        {
                                            errors.bxbPickupPointAddress &&
                                            JSON.stringify(errors.npiPickupPointAddress.region)
                                        }
                                    </small>
                                </Col>
                                <Col sm="6">
                                    {/*<InputGroup>*/}
                                    {/*    <Prepend text="City"/>*/}
                                    {/*    <Form.Control*/}
                                    {/*        as="select"*/}
                                    {/*        onChange={(event) => {*/}
                                    {/*            setFieldValue('bxbPickupPointAddress.city', event.target.value);*/}
                                    {/*            setFieldValue('bxbPickupPointAddress.street', null);*/}
                                    {/*            this.loadStreets(event.target.value);*/}
                                    {/*        }}*/}
                                    {/*        value={values.bxbPickupPointAddress.city || ""}*/}
                                    {/*        isInvalid=*/}
                                    {/*            {*/}
                                    {/*                touched.bxbPickupPointAddress &&*/}
                                    {/*                touched.bxbPickupPointAddress.city &&*/}
                                    {/*                errors.bxbPickupPointAddress &&*/}
                                    {/*                errors.bxbPickupPointAddress.city*/}
                                    {/*            }*/}
                                    {/*        disabled={!values.bxbPickupPointAddress.region}*/}
                                    {/*    >*/}
                                    {/*        <option defaultValue />*/}
                                    {/*        {*/}
                                    {/*            this.state.cities.map(*/}
                                    {/*                (each, index) => (*/}
                                    {/*                    <option value={each["label"]} key={each["value"]}>{each["label"]}</option>)*/}
                                    {/*            )*/}
                                    {/*        }*/}
                                    {/*    </Form.Control>*/}
                                    {/*    <Form.Control.Feedback type="invalid">*/}
                                    {/*        {*/}
                                    {/*            errors.bxbPickupPointAddress &&*/}
                                    {/*            errors.bxbPickupPointAddress.city*/}
                                    {/*        }*/}
                                    {/*    </Form.Control.Feedback>*/}
                                    {/*</InputGroup>*/}
                                    <Select
                                        className="flex-fill"
                                        classNamePrefix="react-select"
                                        isSearchable
                                        value={values.bxbPickupPointAddress.city}
                                        onChange={(city) => {
                                            setFieldValue('bxbPickupPointAddress.city', city);
                                            setFieldValue('bxbPickupPointAddress.street', null);
                                            this.loadStreets(city.label);
                                        }}
                                        options={this.state.cities}
                                        placeholder="City"
                                        isDisabled={!values.bxbPickupPointAddress.region}
                                    />
                                    <small style={{color: 'red'}}>
                                        {
                                            errors.bxbPickupPointAddress &&
                                            JSON.stringify(errors.npiPickupPointAddress.city)
                                        }
                                    </small>
                                </Col>
                            </Row>
                        </Form.Group>
                        <Form.Group>
                            <Row>
                                <Col sm="12">
                                    {/*<InputGroup>*/}
                                    {/*    <Prepend text="Street"/>*/}
                                    {/*    <Form.Control*/}
                                    {/*        as="select"*/}
                                    {/*        onChange={(event) => {*/}
                                    {/*            setFieldValue('bxbPickupPointAddress.street', event.target.value);*/}
                                    {/*        }}*/}
                                    {/*        value={values.bxbPickupPointAddress.street || ""}*/}
                                    {/*        isInvalid=*/}
                                    {/*            {*/}
                                    {/*                touched.bxbPickupPointAddress &&*/}
                                    {/*                touched.bxbPickupPointAddress.street &&*/}
                                    {/*                errors.bxbPickupPointAddress &&*/}
                                    {/*                errors.bxbPickupPointAddress.street*/}
                                    {/*            }*/}
                                    {/*        disabled={!values.bxbPickupPointAddress.city}*/}
                                    {/*    >*/}
                                    {/*        <option defaultValue />*/}
                                    {/*        {*/}
                                    {/*            this.state.streets.map(*/}
                                    {/*                (each, index) => (*/}
                                    {/*                    <option value={each["label"]} key={each["value"]}>{each["label"]}</option>)*/}
                                    {/*            )*/}
                                    {/*        }*/}
                                    {/*    </Form.Control>*/}
                                    {/*    <Form.Control.Feedback type="invalid">*/}
                                    {/*        {*/}
                                    {/*            errors.bxbPickupPointAddress &&*/}
                                    {/*            errors.bxbPickupPointAddress.street*/}
                                    {/*        }*/}
                                    {/*    </Form.Control.Feedback>*/}
                                    {/*</InputGroup>*/}
                                    <Select
                                        className="flex-fill"
                                        classNamePrefix="react-select"
                                        isSearchable
                                        value={values.bxbPickupPointAddress.street}
                                        onChange={(street) => {
                                            setFieldValue('bxbPickupPointAddress.street', street);
                                        }}
                                        options={this.state.streets}
                                        placeholder="Street"
                                        isDisabled={!values.bxbPickupPointAddress.city}
                                    />
                                    <small style={{color: 'red'}}>
                                        {
                                            errors.bxbPickupPointAddress &&
                                            JSON.stringify(errors.npiPickupPointAddress.street)
                                        }
                                    </small>
                                </Col>
                            </Row>
                        </Form.Group>
                    </Form.Group>
                </Form.Group>
            </div>
        );
    }
}
